<template>
  <!--
    ref="editablePage" est utilisé pour accéder aux propriétés de la page de n'importe quel component 
    Solution:
    this.$root.$children[0].$children.find(el => el.$refs && el.$refs.editablePage != undefined).$refs.editablePage.content
  -->
  <EditablePage
    v-if="content"
    ref="editablePage"
    :content="content"
    :config="config"
    :templateDefinitions="templateDefinitions"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import config from '@/magnolia.config';
import { EditablePage } from '@/vue-editor';
import {
  getUrlContext,
  inEditor,
  // Code original Magnolia
  // getLanguages,
  // getCurrentLanguage,
  // removeCurrentLanguage,
  getVersion,
} from '@/helpers/AppHelpers';

// import store from "@/store";

import i18n from '@/js/i18n';

export default {
  name: 'PageLoader',
  components: {
    EditablePage,
  },
  props: { windowLocationPathname: { type: String } },
  data() {
    return {
      content: undefined,
      config,
      templateDefinitions: {},
    };
  },
  computed: {
    ...mapGetters('routes', ['getRouteByPath']),
  },
  mounted() {
    this.loadPage();
  },
  updated() {
    if (inEditor) window.parent.mgnlRefresh();
  },
  methods: {
    async loadPage() {
      const contentResponse = await fetch(await this.getContentUrl());
      const content = await contentResponse.json();

      if (inEditor) {
        const templateDefinitionsResponse = await fetch(
          getUrlContext(
            `${process.env.VUE_APP_REST_TEMPLATE_DEFINITION}/${content['mgnl:template']}`
          )
        );
        const templateDefinitions = await templateDefinitionsResponse.json();

        this.templateDefinitions = templateDefinitions;
      }

      this.content = content;
    },
    async getContentUrl() {
      // Code original Magnolia
      // const languages = getLanguages();

      const nodeName = process.env.VUE_APP_SITE_BASENAME;
      const currentLanguage = i18n.locale;

      // Code original Magnolia
      // let path =
      //  nodeName +
      //  window.location.pathname.replace(new RegExp("(.*" + nodeName + "|.html)", "g"), "");
      // if (currentLanguage !== languages[0]) {
      //  path = removeCurrentLanguage(path, currentLanguage);
      //  path += "?lang=" + currentLanguage;
      // }

      const { websitePath } = this.getRouteByPath(
        this.windowLocationPathname ?? window.location.pathname
      );
      let path;

      if (websitePath) {
        path = websitePath;
      } else {
        console.log('!websitePath');
        path = nodeName + this.jel_getMagnoliaPathName();
      }

      path += `?lang=${currentLanguage}`;

      const version = getVersion(window.location.href);
      if (version) {
        path += path.indexOf('?') > -1 ? `&version=${version}` : `?version=${version}`;
      }

      return `${getUrlContext(
        version ? process.env.VUE_APP_REST_PAGES_PREVIEW : process.env.VUE_APP_REST_PAGES
      )}${path}`;
    },
  },
};
</script>
